import { VipPromoKind } from './constants';

export const normalizeOptionalRank = value => {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  const numericRank = Number(value);
  return Number.isInteger(numericRank) && numericRank > 0 ? numericRank : null;
};

export const getRankOptions = (itemCount, currentRank) => {
  const normalizedCount = Number.isInteger(Number(itemCount)) ? Number(itemCount) : 0;
  const normalizedCurrentRank = normalizeOptionalRank(currentRank) ?? 0;
  const maxRank = Math.max(normalizedCount, normalizedCurrentRank, 1);

  return Array.from({ length: maxRank }, (_, index) => index + 1);
};

export const validateLeaderboardRanks = (items = [], vipPromoKind) => {
  if (vipPromoKind !== VipPromoKind.LEADERBOARD) {
    return '';
  }

  const hasInvalidRank = items.some(item => {
    const rank = item?.rank;
    return (
      rank !== undefined && rank !== null && rank !== '' && normalizeOptionalRank(rank) === null
    );
  });

  if (hasInvalidRank) {
    return 'Leaderboard item ranks must be whole numbers starting at 1.';
  }

  const ranks = items.map(item => normalizeOptionalRank(item?.rank)).filter(rank => rank !== null);

  if (new Set(ranks).size !== ranks.length) {
    return 'Leaderboard item ranks must be distinct.';
  }

  const sortedRanks = [...ranks].sort((a, b) => a - b);
  const hasGap = sortedRanks.some((rank, index) => rank !== index + 1);

  if (hasGap) {
    return 'Leaderboard item ranks must be contiguous starting at 1.';
  }

  return '';
};
